export const roundNumber = (
  number: number | string,
  decimalNumber: number,
  defaultValue: string = "-",
): string => {
  return (typeof number === "number" ||
    (typeof number === "string" && number?.match(/^ *$/) === null)) &&
    !isNaN(Number(number))
    ? Number(number).toFixed(decimalNumber)
    : defaultValue;
};

export const formatNumberValue = (
  value: number | string | undefined,
  emptyValueChar = "-",
  minDigits?: number,
  maxDigits?: number,
) => {
  const isIncorrectValue =
    (typeof value !== "string" && typeof value !== "number") ||
    isNaN(Number(value)) ||
    value === "";

  const userLocale =
    navigator.languages?.length > 0
      ? navigator.languages[0]
      : navigator.language;

  return isIncorrectValue
    ? emptyValueChar
    : new Intl.NumberFormat(userLocale, {
        maximumFractionDigits: maxDigits || 6,
        minimumFractionDigits: minDigits,
        useGrouping: true,
      }).format(Number(value));
};

export const formatCurrencyValue = (
  value: number | string | undefined,
  emptyValueChar = "-",
  currencyCode?: string,
) => {
  const code = currencyCode ? ` ${currencyCode}` : "";

  return `${formatNumberValue(value, emptyValueChar, 2, 2)}${code}`;
};

export const abbreviateNumber = (value?: number) => {
  if (!value) {
    return 0;
  }

  const userLocale =
    navigator.languages?.length > 0
      ? navigator.languages[0]
      : navigator.language;

  return new Intl.NumberFormat(userLocale, {
    notation: "compact",
  })?.format(value);
};
